import config from "../config";

const DAY_LABELS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
const CARD_GRADIENTS = [
  "linear-gradient(135deg,#1a0d2e 0%,#4d2070 50%,#8c084a 100%)",
  "linear-gradient(135deg,#0d182e 0%,#1a3d5e 50%,#0f4c81 100%)",
  "linear-gradient(135deg,#2e0d1a 0%,#5e1a3d 50%,#a02f6b 100%)",
];

const formatDateBadge = (timestamp) => {
  if (!timestamp) return null;
  const d = new Date(timestamp);
  const day = DAY_LABELS[d.getDay()];
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${day} ${dd}.${mm}`;
};

const buildFeaturedEventsHtml = (events) => {
  if (!events.length) return "";
  const shown = events.slice(0, 3);
  const total = shown.length;

  const cards = shown.map((e, i) => {
    const badge = formatDateBadge(e.date);
    const gradient = CARD_GRADIENTS[i % CARD_GRADIENTS.length];
    const imageUrl = config.cdnUrl ? `${config.cdnUrl}/events/${e.id}` : null;
    const bgStyle = imageUrl
      ? `background-image:url('${imageUrl}');background-size:cover;background-position:center;background-color:${gradient.match(/#[0-9a-f]+/i)?.[0] || "#1a0d2e"};`
      : `background:${gradient};`;
    const width =
      total === 1 ? "100%" : total === 2 ? "50%" : i === 2 ? "34%" : "33%";
    const pad =
      total === 1
        ? ""
        : i === 0
          ? "padding-right:7px;"
          : i === total - 1
            ? "padding-left:7px;"
            : "padding-left:4px;padding-right:3px;";

    return `
          <td class="card-col" valign="top" width="${width}" style="${pad}">
            <div class="card-img-div" style="${bgStyle}border-radius:16px;overflow:hidden;height:181px;">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                  <td valign="top" align="left" height="181" style="padding:10px;background:linear-gradient(180deg,rgba(0,0,0,0.1) 0%,rgba(0,0,0,0.5) 100%);">
                    ${badge ? `<table role="presentation" cellspacing="0" cellpadding="0" border="0"><tr><td bgcolor="#D21B89" align="center" style="border-radius:12px;padding:4px 10px;"><span style="font-family:'Montserrat',Arial,sans-serif;font-size:11px;font-weight:700;color:#ffffff;white-space:nowrap;line-height:15px;display:block;">${badge}</span></td></tr></table>` : ""}
                  </td>
                </tr>
              </table>
            </div>
            <p style="margin:10px 0 3px;font-family:'Montserrat',Arial,sans-serif;font-size:13px;font-weight:700;color:#ffffff;line-height:18px;">${e.name || "(unnamed)"}</p>
            ${e.venueName ? `<p style="margin:0;font-family:'Montserrat',Arial,sans-serif;font-size:11px;font-weight:600;color:#a796cc;line-height:16px;">${e.venueName}</p>` : ""}
          </td>`;
  });

  return `
  <tr>
    <td bgcolor="#160b24" class="pad" style="padding:32px 20px 24px;">
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:18px;">
        <tr>
          <td width="4" valign="middle" style="padding-right:10px;">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
              <tr><td width="4" height="18" bgcolor="#D21B89" style="border-radius:2px;font-size:0;line-height:0;">&nbsp;</td></tr>
            </table>
          </td>
          <td valign="middle">
            <span style="font-family:'Montserrat',Arial,sans-serif;font-size:14px;font-weight:700;color:#ffffff;text-transform:uppercase;letter-spacing:2.5px;line-height:18px;">Featured Events</span>
          </td>
        </tr>
      </table>
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
        <tr>${cards.join("")}</tr>
      </table>
    </td>
  </tr>`;
};

const formatEventDate = (timestamp) => {
  if (!timestamp) return null;
  return new Date(timestamp).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const buildMoreEventsHtml = (events) => {
  if (!events || !events.length) return "";

  const buildCell = (e, extraStyle, width) => {
    const date = formatEventDate(e.date);
    const dateStr = date ? date.replace(/\//g, ".") : "";
    const meta = [e.venueName, dateStr].filter(Boolean).join(" · ");
    const imageUrl = config.cdnUrl ? `${config.cdnUrl}/events/${e.id}` : null;
    const thumbStyle = imageUrl
      ? `width:50px;height:50px;min-width:50px;min-height:50px;border-radius:8px;background-image:url('${imageUrl}');background-size:cover;background-position:center;background-color:#2A1A3A;font-size:0;line-height:0;`
      : `width:50px;height:50px;min-width:50px;min-height:50px;border-radius:8px;background-color:#2A1A3A;font-size:0;line-height:0;`;
    return `
        <td class="list-col" valign="top" width="${width}" style="padding:14px;${extraStyle}">
          <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%"><tr>
            <td valign="middle" style="padding-right:10px;width:50px;min-width:50px;">
              <div style="${thumbStyle}">&nbsp;</div>
            </td>
            <td valign="middle">
              <p style="margin:0 0 2px;font-family:'Montserrat',Arial,sans-serif;font-size:12px;font-weight:600;color:#ffffff;line-height:16px;">${e.name || "(unnamed)"}</p>
              ${meta ? `<p style="margin:0;font-family:'Montserrat',Arial,sans-serif;font-size:10px;font-weight:400;color:#857E94;line-height:15px;">${meta}</p>` : ""}
            </td>
          </tr></table>
        </td>`;
  };

  const rows = [];
  for (let i = 0; i < events.length; i += 2) {
    const isLast = i + 2 >= events.length;
    const borderBottom = isLast ? "" : "border-bottom:1px solid #2A1A3A;";
    const left = buildCell(
      events[i],
      borderBottom + "border-right:1px solid #2A1A3A;",
      "50%"
    );
    const right = events[i + 1]
      ? buildCell(events[i + 1], borderBottom, "50%")
      : `<td class="list-col" valign="top" width="50%" style="padding:14px;">&nbsp;</td>`;
    rows.push(`<tr>${left}${right}</tr>`);
  }

  return `
  <tr>
    <td bgcolor="#160b24" style="padding:0 20px;">
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
        <tr><td height="1" style="background:linear-gradient(90deg,transparent,rgba(210,27,137,0.25) 30%,rgba(210,27,137,0.25) 70%,transparent);font-size:0;line-height:0;">&nbsp;</td></tr>
      </table>
    </td>
  </tr>
  <tr>
    <td bgcolor="#160b24" class="pad" style="padding:28px 20px 32px;">
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom:14px;">
        <tr>
          <td width="4" valign="middle" style="padding-right:10px;">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
              <tr><td width="4" height="18" bgcolor="#D21B89" style="border-radius:2px;font-size:0;line-height:0;">&nbsp;</td></tr>
            </table>
          </td>
          <td valign="middle">
            <span style="font-family:'Montserrat',Arial,sans-serif;font-size:14px;font-weight:700;color:#ffffff;text-transform:uppercase;letter-spacing:2.5px;line-height:18px;">More This Week</span>
          </td>
        </tr>
      </table>
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%"
        style="background-color:#190D28;border-radius:10px;border:1px solid #2A1A3A;">
        ${rows.join("")}
      </table>
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-top:20px;">
        <tr>
          <td align="center">
            <a href="https://app.viby-music.com/events" style="display:inline-block;background-color:#D21B89;background-image:linear-gradient(135deg,#D21B89 0%,#8c084a 100%);font-family:'Montserrat',Arial,sans-serif;font-size:13px;font-weight:700;color:#ffffff;text-decoration:none;padding:13px 40px;border-radius:30px;letter-spacing:0.5px;line-height:1;">
              View All Events
            </a>
          </td>
        </tr>
      </table>
    </td>
  </tr>`;
};

export const buildBulkEmailPreviewHtml = ({
  subject,
  selectedEvents,
  moreEvents = [],
  heroImageUrl,
}) => {
  const featuredSection = buildFeaturedEventsHtml(selectedEvents);
  const moreSection = buildMoreEventsHtml(moreEvents);

  return `<!DOCTYPE html>
<html lang="en" xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${subject}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap');
    * { box-sizing: border-box; }
    body { margin: 0; padding: 0; background-color: #160b24; }
    a { color: inherit; text-decoration: none; }
    @media screen and (max-width: 620px) {
      .email-wrap { width: 100% !important; }
      .card-col { display: block !important; width: 100% !important; padding: 0 0 12px 0 !important; }
      .card-col:last-child { padding-bottom: 0 !important; }
      .card-img-div { height: 240px !important; }
      .pad { padding-left: 16px !important; padding-right: 16px !important; }
    }
  </style>
</head>
<body style="margin:0;padding:0;background-color:#160b24;">

<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#160b24;">
<tr><td align="center" valign="top">
<table role="presentation" class="email-wrap" cellspacing="0" cellpadding="0" border="0" width="600" style="max-width:600px;">

  <!-- Accent bar -->
  <tr>
    <td height="3" style="background:linear-gradient(90deg,#8c084a 0%,#D21B89 50%,#8c084a 100%);font-size:0;line-height:0;border-radius:16px 16px 0 0;">&nbsp;</td>
  </tr>

  <!-- HEADER -->
  <tr>
    <td bgcolor="#190D28" class="pad" style="padding:20px 28px 0;">
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
        <tr>
          <td valign="middle">
            <span style="font-family:'Montserrat',Arial,sans-serif;font-size:26px;font-weight:800;font-style:italic;color:#D21B89;letter-spacing:1px;line-height:30px;">VIBY</span>
          </td>
          <td valign="middle" align="right">
            <span style="font-family:'Montserrat',Arial,sans-serif;font-size:11px;font-weight:400;font-style:italic;color:#857E94;line-height:16px;">You choose the music tonight</span>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <tr><td bgcolor="#190D28" style="padding:0 0 24px;font-size:0;line-height:0;">&nbsp;</td></tr>

  <!-- HERO -->
  <tr>
    <td style="padding:0;font-size:0;line-height:0;">
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%"
        style="background-image:url('${heroImageUrl || "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&h=320&fit=crop&q=80"}');background-size:cover;background-position:center top;background-color:#190D28;">
        <tr>
          <td valign="bottom" width="100%" height="320"
            style="background:linear-gradient(180deg,rgba(25,13,40,0.55) 0%,rgba(22,11,36,0.3) 35%,rgba(22,11,36,0.75) 65%,rgba(22,11,36,1) 100%);padding:0 28px 30px;">
            <h1 style="margin:0;font-family:'Montserrat',Arial,sans-serif;font-size:28px;font-weight:800;color:#ffffff;letter-spacing:-0.5px;line-height:34px;">${subject}</h1>
          </td>
        </tr>
      </table>
    </td>
  </tr>

  <!-- FEATURED EVENTS -->
  ${featuredSection}

  <!-- MORE THIS WEEK -->
  ${moreSection}

  <!-- FOOTER -->
  <tr>
    <td bgcolor="#0e0718" style="padding:28px 28px 24px;border-radius:0 0 16px 16px;border-top:1px solid #2A1A3A;">
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
        <tr><td align="center" style="padding-bottom:8px;">
          <span style="font-family:'Montserrat',Arial,sans-serif;font-size:20px;font-weight:800;font-style:italic;color:#D21B89;letter-spacing:1px;line-height:24px;">VIBY</span>
        </td></tr>
        <tr><td align="center" style="padding-bottom:20px;">
          <span style="font-family:'Montserrat',Arial,sans-serif;font-size:11px;font-weight:400;font-style:italic;color:#857E94;line-height:16px;">You choose the music tonight</span>
        </td></tr>
        <tr><td style="padding-bottom:20px;font-size:0;line-height:0;">
          <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
            <tr><td height="1" bgcolor="#2A1A3A" style="font-size:0;line-height:0;">&nbsp;</td></tr>
          </table>
        </td></tr>
        <tr><td align="center" style="padding-bottom:16px;">
          <span style="display:inline-block;font-family:'Montserrat',Arial,sans-serif;font-size:12px;font-weight:400;color:#4a4255;padding:8px 24px;letter-spacing:0.5px;line-height:16px;">Unsubscribe</span>
        </td></tr>
        <tr><td align="center">
          <p style="margin:0 0 4px;font-family:'Montserrat',Arial,sans-serif;font-size:11px;font-weight:400;color:#857E94;line-height:18px;">
            &copy; 2026 VIBY &nbsp;&middot;&nbsp; <a href="https://app.viby-music.com/privacypolicy" style="color:#857E94;text-decoration:none;">Privacy Policy</a> &nbsp;&middot;&nbsp; <a href="https://app.viby-music.com/termsofuse" style="color:#857E94;text-decoration:none;">Terms of Use</a>
          </p>
          <p style="margin:0;font-family:'Montserrat',Arial,sans-serif;font-size:10px;font-weight:300;color:rgba(133,126,148,0.45);line-height:16px;">
            You received this because you opted in to VIBY event updates.
          </p>
        </td></tr>
      </table>
    </td>
  </tr>

  <tr><td height="24" bgcolor="#160b24" style="font-size:0;line-height:0;">&nbsp;</td></tr>

</table>
</td></tr>
</table>
</body>
</html>`;
};
